<span
  class="contracts-combo__title"
  data-hj-suppress=""
  [class.skeleton]="!selectedContractName"
  data-recording-sensitive
  (click)="toggleCombo()"
>
  {{ selectedContractName }}
  <img
    *ngIf="moreThanOneContract"
    class="contracts-combo__toggle-icon"
    [ngClass]="{ 'contracts-combo__toggle-icon--closed': showItems }"
    src="images/icons/atm-arrow-icn-open.svg"
    [alt]="!showItems ? 'Abrir' : 'Cerrar'"
  />
</span>
<div
  class="contracts-combo"
  *ngIf="moreThanOneContract && showItems"
  (clickOutside)="toggleCombo()"
>
  <div
    (click)="changeContract(contract.contractId)"
    *ngFor="let contract of contracts"
    class="contracts-combo__item"
    [ngClass]="{ active: selectedContract === contract.contractId }"
    data-hj-suppress=""
    data-recording-sensitive
  >
    <label
      class="contracts-combo__name"
      [ngClass]="{ active: selectedContract === contract.contractId }"
      >{{ contract?.strategyName }}</label
    >
    <label class="contracts-combo__id">ID: {{ contract.contractId }}</label>
  </div>
</div>
